import _ from 'lodash';
import * as React from 'react';

import { ContractorBlock } from './ContractorBlock';
import { PlatinumContractorLevel, PreferredContractorLevel } from './ContractorLevels';
import { FindAContractorConnector } from '../../redux/connectors/FindAContractorConnector';
import { connectLocation } from '../location/LocationConnectors';

const SkipToFooter = connectLocation(({ t }) => (
  <a href="#oc-footer" className="skip-to-footer">
    {t('contractors.scroll_to_footer')}
  </a>
));

const Contractors = ({ contractors, openModal }) => (
  <>
    {contractors.map((contractor, index) => {
      const interval = 10;
      const everyAfterInterval = !((index + 1) % interval);
      return (
        <React.Fragment key={index}>
          <ContractorBlock key={contractor.mas_dealer_code} {...contractor} openModal={openModal} />
          {everyAfterInterval && <SkipToFooter />}
        </React.Fragment>
      );
    })}
  </>
);

const PlatinumContractors = ({ contractors, filters, openModal }) => {
  if (_.isEmpty(contractors)) return null;

  const show = filters.contractor_level.length === 0 || filters.contractor_level.includes('platinum_preferred');
  if (!show) return null;

  return (
    <div className="contractor-level-wrapper">
      <PlatinumContractorLevel />
      <Contractors contractors={contractors} openModal={openModal} />
    </div>
  );
};

const OtherContractors = ({ contractors, filters, openModal }) => {
  if (_.isEmpty(contractors)) return null;

  const show = filters.contractor_level.length === 0 || filters.contractor_level.includes('preferred');
  if (!show) return null;

  return (
    <div className="contractor-level-wrapper">
      <PreferredContractorLevel />
      <Contractors contractors={contractors} openModal={openModal} />
    </div>
  );
};

const ContractorList = ({ filteredContractors, filters, openModal, t, totalCount }) => {
  const showNoFilterResults = totalCount > 0 && _.isEmpty(filteredContractors);
  const { platinum = [], other = [] } = _.groupBy(filteredContractors, contractor =>
    contractor.is_preferred_platinum ? 'platinum' : 'other'
  );

  return (
    <div aria-live="polite" id="contractor-list">
      {showNoFilterResults && (
        <p className="fac-no-results">
          {t('contractors.contractors_summary.no_filter_results')}
        </p>
      )}
      <PlatinumContractors contractors={platinum} filters={filters} openModal={openModal} />
      <OtherContractors contractors={other} filters={filters} openModal={openModal} />
    </div>
  );
};

export default _.flow(FindAContractorConnector, connectLocation)(ContractorList);
